import { apiClient } from "shared/api/client";

export const getOrganizationMenu = ({ apiUrl, organizationSymbol }) => {
  return apiClient(
    `${apiUrl}/ti/api/v1/${organizationSymbol}/organizationmenu`
  );
};